module.exports = __webpack_public_path__ + "static/media/Group 136.721c5c81.jpg";